import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPendingLabourInward,
  fetchPendingLabourInwardById,
} from "./thunk";

interface PendingInwardState {
  list: any[];
  rowCount: number;
  loading: boolean;
  selectedInward: any | null;
  error: string | null;
}

const initialState: PendingInwardState = {
  list: [],
  rowCount: 0,
  loading: false,
  selectedInward: null,
  error: null,
};

export const pendingLabourInwardSlice = createSlice({
  name: "PendingLabourInward",
  initialState,
  reducers: {
    clearPendingLabourInwardDetails(state) {
      state.selectedInward = null;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    // -----------------------------------
    // FETCH LIST
    // -----------------------------------
    builder.addCase(fetchPendingLabourInward.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPendingLabourInward.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload.data;
      state.rowCount = action.payload.rowCount;
    });
    builder.addCase(fetchPendingLabourInward.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // -----------------------------------
    // FETCH BY ID
    // -----------------------------------
    builder.addCase(fetchPendingLabourInwardById.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.selectedInward = null;
    });
    builder.addCase(fetchPendingLabourInwardById.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedInward = action.payload;
    });
    builder.addCase(fetchPendingLabourInwardById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export const { clearPendingLabourInwardDetails } =
  pendingLabourInwardSlice.actions;

export default pendingLabourInwardSlice.reducer;
